$('.flex-banner').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  autoplay: true,
  autoplaySpeed: 5000,
     responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



$('.flex-location').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
     responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$(document).ready(function(){
  $('.bannerMain').slick({
    dots: false,
    adaptiveHeight: true,
    arrows:true,
    autoplay: true,
    autoplaySpeed: 5000,                  
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 749,
        settings: {        
          infinite: true,
          dots: true,
          arrows:false,
        }
      }
    ]
  });
  $('.testmonialSectionwrapper, .reviewWrapper').slick({
    dots: false,
    arrows:false,
    autoplay: false,
    autoplaySpeed: 5000,                  
    slidesToShow: 3,
    slidesToScroll: 3,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          infinite: true,
          autoplay: true,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
    $('.revipesWrapper.recipeslider').slick({
    dots: false,
    arrows:true,
    autoplay: false,
    autoplaySpeed: 5000,                  
    slidesToShow: 3,
    slidesToScroll: 3,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          infinite: true,
          autoplay: true,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
     $('.revipesWrapper.recipeslider').slick('unslick');
      if ($(window).width() < 750) {
        
      $('.revipesWrapper').slick({
      dots: true,
      arrows:false,
      autoplay: false,
      autoplaySpeed: 5000,                  
      adaptiveHeight: true,
      infinite: true,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1
      
      
      
      }); 
      }
  $('.page--featured').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,   
    arrows:true,
    dots: false,
    responsive: [
      {
        breakpoint: 1190,
        settings: {
              slidesToShow: 4,
        }
      },
      {
        breakpoint: 999,
        settings: {
          dots: false,
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 749,
        settings: "unslick"
      }
    ]
  });

  
  $('.page--featured2').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,   
    arrows:true,
    dots: false,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:false
        }
      }
    ]
  });

  $(".header__inline-menu .list-menu>*").hover(function(){
    $(".navBar").toggleClass("active"); 
  });
  $(".header__inline-menu .list-menu> li").hover(function(){
    $(this).toggleClass("hoverli"); 
  });

});


$(document).ready(function(){
  $(".footer-block__heading").click(function () {
  // If the clicked element has the active class, remove the active class from EVERY .nav-link>.state element
  if ($(this).hasClass("active")) {
    $(".footer-block__heading").removeClass("active");
  }
  // Else, the element doesn't have the active class, so we remove it from every element before applying it to the element that was clicked
  else {
    $(".footer-block__heading").removeClass("active");
    $(this).addClass("active");
  }
});
  $('.menu--parent > ul').scroll(function() {
    var scrollTop = $(this).scrollTop();
    var scrollHeight = $(this)[0].scrollHeight;
    var height = $(this).outerHeight();

    if (scrollTop + height + 30 >= scrollHeight) {
      $(this).addClass('at-bottom');
    } else {
      $(this).removeClass('at-bottom');
    }
  });
});

if ($(window).width() < 750) {

  $('.product__media-list').slick({
    infinite: false,
    dots: true,
    arrows:false,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1
    
  });
 
  //   $('.blog__posts').slick({
  //   infinite: false,
  //   dots: true,
  //   arrows:false,
  //   adaptiveHeight: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1
    
  // });
  }
$('.menu-drawer-container .header__icon--summary').click(function(){
$('.navBar').addClass('openmenu');
  $('html').addClass('overflow-hidden-tablet');
});
$('.navBar .navBar--header svg').click(function(){
$('.navBar').removeClass('openmenu');
  $('html').removeClass('overflow-hidden-tablet');
});

$('.menu-item h2').click(function(){
   let thus=$(this).parent('div');
    thus.next().slideToggle();
    $(this).toggleClass('openm');
});


function readmore(){ 
  
    $('.product__description span.readmore').click(function(){
    $('.product__description').addClass('readlessenb');
});
    $('.product__description span.readless').click(function(){
    $('.product__description').removeClass('readlessenb');
        $('html, body').animate({
                scrollTop: $('.breadcrumb').offset().top
            }, 500);
});
}

readmore()
$('.quantity__input, .quantity__button').on("click change",function(){
    let val1=$('.quantity__input').val();
    if(val1< 1){
      $('.quantity__input').val(1)  ;
    }
});
let val1=$('.article-template').data('articleid');
$('.blog__posts .blog__post').each(function(){
   let val2=$(this).data('articleid');
    if(val1==val2){
        $(this).remove();
    }
  if ($(window).width() < 750) {
    $('.blog__posts').slick({
    infinite: false,
    dots: true,
    arrows:false,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1
    
  });
  }
});
 $('.recipeColumns').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,   
    arrows:true,
    dots: false,
    responsive: [
       {
        breakpoint: 990,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows:true
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows:true
        }
      }
    ]
  });
